<template>
	<section class="m-report-page">
		<div class="m-report-charts">
			<div class="m-report-charts__wrapper">
				<div class="m-report-charts--block">
					<h2 class="m-report__title m-report__title--small">
						{{ product.title }}
					</h2>
					<p class="m-report__subtitle m-report__subtitle--small">
						Выдача ипотеки по продуктам
					</p>
					<div class="m-report-charts__product">
						<product-chart
							id-chart="product_chart"
							:data="product.periods"
							:sources="product.sources"
							:hint="product.hints"
							:limit="limit"
							:key="render"
						></product-chart>
					</div>
				</div>
				<div class="m-report-charts--block">
					<h2 class="m-report__title m-report__title--small">
						{{ programs.title }}
					</h2>
					<p class="m-report__subtitle m-report__subtitle--small">
						Выдача ипотеки по госпрограммам
					</p>
					<div class="m-report-charts__product">
						<product-chart
							id-chart="programs_chart"
							:data="programs.periods"
							:sources="programs.sources"
							:hint="programs.hints"
							:limit="limit"
							add-text="Ретроспективные данные могут меняться из-за корректировки отчетности банков"
							:key="render"
						></product-chart>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import ProductChart from './ProductChart.vue'
import { throttle } from 'throttle-debounce'

export default {
	name: 'Charts',
	components: {
		ProductChart,
	},
	props: {
		product: {
			type: Object,
		},
		programs: {
			type: Object,
		},
		limit: {
			type: Number,
		},
	},
	data() {
		return {
			render: null,
		}
	},
	created() {
		window.addEventListener('resize', throttle(300, this.setHeightChart))
	},
	computed: {
		getLegendProduct() {
			return this.legend.reverse()
		},
	},
	methods: {
		setHeightChart() {
			this.render += 1
		},
	},
}
</script>
